import { pick } from "@pathwright/ux/src/components/filestack/api"
import { MEDIA_TYPES } from "@pathwright/ux/src/components/filestack/constants"
import { getOptions } from "@pathwright/ux/src/components/filestack/utils"
import ReactQuill from "react-quill"

const BlockEmbed = ReactQuill.Quill.import("blots/block/embed")

/**
 * Insert an image embed at the given Quill range (replacing any selected text).
 * Shared by toolbar Filestack handler and slash-command MediaManager flow.
 */
export function insertQuillImage(quill, range, { url, alt }) {
  if (!quill || !range || !url) return

  let index = range.index

  if (range.length) {
    quill.deleteText(range.index, range.length, "api")
  }

  quill.insertEmbed(
    index,
    "image",
    { url, alt: alt || "" },
    "user" // source
  )
}

// handles image Quill toolbar option using Filestack
export const handleImage = async function () {
  const quill = this.quill
  // get initial range now before quill loses focus
  let range = quill.getSelection()

  const handleImagesUploaded = ({ filesUploaded }) => {
    if (filesUploaded && filesUploaded.length) {
      filesUploaded.forEach((image) => {
        // update range after each embed is inserted
        range = quill.getSelection() || range

        if (range) {
          insertQuillImage(quill, range, {
            url: image.url,
            alt: image.filename
          })
        }
      })
    }
  }

  pick(getOptions(MEDIA_TYPES.IMAGE)).then(handleImagesUploaded)
}

// Quill provides a default "image" blot but it only handles the src attribute,
// and this way we can also provide an alt based on the image filename
// see: https://quilljs.com/guides/cloning-medium-with-parchment/#images
class ImageBlot extends BlockEmbed {
  static create(value) {
    let node = super.create()
    node.setAttribute("alt", value.alt)
    node.setAttribute("src", value.url)
    return node
  }

  static value(node) {
    return {
      alt: node.getAttribute("alt"),
      url: node.getAttribute("src")
    }
  }
}

ImageBlot.blotName = "image"
ImageBlot.tagName = "img"

export default ImageBlot
